import Map from './Map'

import { useIsShowingResults } from '../../search/hooks'

import SearchWidget from '../../search/components/SearchWidget'
import Legend from '../../legend/components/Legend'
import LoadingIndicator from './LoadingIndicator'
import DetailsLabel from './DetailsLabel'
import Zoom from './Zoom'
import LocateButton from './LocateButton'
import BasemapSwitch from './BasemapSwitch'
import LegendLayer from './LegendLayer'
import SearchResultsLayer from '../../search/components/SearchResultsLayer'
import ParcelLayer from './ParcelLayer'

const MapSection = function({ id, data, selectedDetailsIndex, details }) {
  const { anchor, url, title, description, sublayers } = data
  const isShowingResults = useIsShowingResults(id)
  return (
    <div id={anchor} className="map-spacer">
      <div className="mym--map-complete-wrapper">
        <section className="mym--map-each-complete">
          <div className="mym--map-image-complete">
            <input
              className="off-the-grid"
              id={`fullscreen${id}`}
              type="checkbox"
            />
            {isShowingResults
              ? <label className="map--fullscreen" style={{ opacity: 0 }} htmlFor={`fullscreen${id}`} href="#"><img src="images/fullscreen-icon.svg" alt="fullscreen icon" /></label>
              : <label className="map--fullscreen" htmlFor={`fullscreen${id}`} href="#"><img src="images/fullscreen-icon.svg" alt="fullscreen icon" /></label>
            }
            <Map id={id}>
              <LegendLayer url={url} sublayers={sublayers} />
              <SearchResultsLayer />
              <ParcelLayer />
              <BasemapSwitch />
              <DetailsLabel index={selectedDetailsIndex} details={details} />
              <LocateButton />
              <Zoom />
              <SearchWidget />
              <LoadingIndicator />
            </Map>
          </div>
          <input className="off-the-grid" id={`mym--carrot${id}`} type="checkbox" />
          <label htmlFor={`mym--carrot${id}`} className="mym--carrot"></label>
          <div className="mym--map-info-complete">
            <h2>{title}</h2>
              <div className="mobile-fix">
                <input id={`map-info${id}`} className="off-the-grid" type="radio" name={`toggle${id}`} />
                <label htmlFor={`map-info${id}`}>Info</label>
                <div className="wrapper--inner">
                  <p>{description}</p>
                </div>
                <input id={`map-layers${id}`} className="off-the-grid" type="radio" name={`toggle${id}`} defaultChecked={true} />
                <label htmlFor={`map-layers${id}`}>Layers</label>
                <Legend url={url} mapId={id} />
              </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default MapSection;